import { EDITORIAL } from "../../data/mock";

export default function Editorial() {
  return (
    <section
      id="editorial"
      data-testid="editorial-section"
      className="py-24 md:py-32 bg-cream-alt border-y border-[#E5E0D8]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-14">
          <div className="max-w-2xl">
            <span className="eyebrow" data-testid="editorial-eyebrow">Editorial</span>
            <h2
              data-testid="editorial-heading"
              className="font-display text-4xl md:text-5xl lg:text-[56px] leading-[1.05] mt-6 text-navy"
            >
              In front of the
              <span className="italic text-terracotta"> lens.</span>
            </h2>
          </div>
          <p className="text-lg text-ink-muted max-w-md">
            Recent editorial and brand campaign work — celebrating mature, embodied,
            unapologetic beauty.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5">
          {EDITORIAL.map((shot, i) => (
            <figure
              key={i}
              data-testid={`editorial-shot-${i}`}
              className={`group relative overflow-hidden bg-navy ${
                i === 0 || i === 3 ? "lg:row-span-2" : ""
              }`}
            >
              <img
                src={shot.src}
                alt={shot.alt}
                loading="lazy"
                className={`w-full object-cover transition-transform duration-700 group-hover:scale-105 ${
                  i === 0 || i === 3 ? "h-[420px] lg:h-[860px]" : "h-[420px] lg:h-[420px]"
                }`}
              />
              <figcaption className="absolute bottom-0 left-0 right-0 px-4 py-3 bg-gradient-to-t from-navy/85 to-transparent text-cream text-xs md:text-sm uppercase tracking-[0.16em] font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                {shot.caption}
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="mt-12 flex flex-wrap items-center gap-4 text-sm text-ink-muted">
          <span className="inline-flex items-center gap-2">
            <span className="w-1.5 h-1.5 bg-mustard rounded-full" />
            Represented for editorial, commercial &amp; brand ambassadorship.
          </span>
          <a
            href="#contact"
            data-testid="editorial-cta"
            className="text-terracotta hover:text-navy transition-colors font-semibold border-b border-terracotta hover:border-navy pb-0.5"
          >
            Book / enquire →
          </a>
        </div>
      </div>
    </section>
  );
}
